<template>
  <div>
    <b-row>
      <b-col
        sm="12"
        class="d-flex justify-content-between pb-0 align-items-center"
      >
        <h1 class="font-weight-bolder">
          {{ $t('customers') }}
        </h1>
        <b-button
          :to="{ name: 'new-customer' }"
          variant="primary"
        >
          {{ $t('create', { type: $t('customer') }) }}
        </b-button>
      </b-col>
      <b-col
        sm="12"
        md="6"
        lg="3"
        class="mb-1"
      >
        <b-form-group class="mr-1 mb-0 w-100">
          <b-input-group class="input-group-merge">
            <b-input-group-prepend is-text>
              <feather-icon icon="SearchIcon" />
            </b-input-group-prepend>
            <b-form-input
              v-model="customerQuery"
              placeholder="Nombre, correo, empresa o telefono"
            />
            <b-input-group-append
              v-if="customerQuery"
              is-text
              class="cursor-pointer"
              @click="customerQuery = ''"
            >
              <feather-icon icon="XIcon" />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <small class="text-muted d-block mt-50">
          {{ resultsLabel }}
        </small>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <customers-table
          :customers="customers"
          :pagination="pagination"
          :loading="customersLoading"
          @refresh="refreshCustomers"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import _ from 'underscore'
import CustomersTable from '@/components/customers/CustomersTable.vue'

export default {
  components: {
    CustomersTable,
  },
  data() {
    return {
      customerQuery: '',
    }
  },
  computed: {
    ...mapGetters('customers', ['customers', 'pagination', 'customersLoading']),

    // Con un filtro puesto conviene decir cuantos quedaron de cuantos hay: si no, la lista
    // recortada se lee como si esos fueran todos los clientes.
    resultsLabel() {
      const total = this.pagination?.total_objects || 0
      if (!this.customerQuery) return `${total} clientes`

      return `${total} ${total === 1 ? 'cliente' : 'clientes'} para "${this.customerQuery}"`
    },
  },

  watch: {
    customerQuery: _.debounce(function search() {
      this.refreshCustomers()
    }, 500),
  },

  created() {
    this.clearProject({})
    this.refreshCustomers()
  },

  methods: {
    ...mapActions('customers', ['fetchCustomers']),

    // La busqueda vive en esta pantalla, asi que cualquier recarga de la tabla tiene que
    // pasar por aqui: si se pide la lista sin estos parametros, el admin pierde el filtro
    // que tenia puesto cada vez que toca algo de un cliente.
    refreshCustomers(page = 1) {
      return this.fetchCustomers({
        byName: this.customerQuery.length ? this.customerQuery : null,
        pagination: {
          page,
          per_page: this.pagination?.per_page || 10,
          all: false,
        },
      })
    },
    ...mapMutations('projects', {
      clearProject: 'SET_PROJECT',
    }),
  },
}
</script>

<style></style>
